import { render } from "./CustomerProfile.vue?vue&type=template&id=684c1283&scoped=true"
import script from "./CustomerProfile.vue?vue&type=script&lang=js"
export * from "./CustomerProfile.vue?vue&type=script&lang=js"

import "./CustomerProfile.vue?vue&type=style&index=0&id=684c1283&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684c1283"]])

export default __exports__